import { render, staticRenderFns } from "./PriceTrend.vue?vue&type=template&id=65eb69a8&scoped=true"
import script from "./PriceTrend.vue?vue&type=script&lang=js"
export * from "./PriceTrend.vue?vue&type=script&lang=js"
import style0 from "./PriceTrend.vue?vue&type=style&index=0&id=65eb69a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65eb69a8",
  null
  
)

export default component.exports